import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { Link } from '@trashlab/sitesapp/src/components/shared/link';

const HomePage = () => {
  return (
    <>
      <h1>Hey this is a different template :)</h1>
      <Link href="/about">Go to about page</Link>
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});
